export default {
  GET_MASTER_LIST_REQUEST: "GET_MASTER_LIST_REQUEST",
  GET_MASTER_LIST_RESPONSE: "GET_MASTER_LIST_RESPONSE",
  POST_MASTER_REQUEST: "POST_MASTER_REQUEST",
  POST_MASTER_RESPONSE: "POST_MASTER_RESPONSE",
  PUT_MASTER_REQUEST: "PUT_MASTER_REQUEST",
  PUT_MASTER_RESPONSE: "PUT_MASTER_RESPONSE",
  PUT_STATUS_MASTER_REQUEST: "PUT_STATUS_MASTER_REQUEST",
  PUT_STATUS_MASTER_RESPONSE: "PUT_STATUS_MASTER_RESPONSE",
  POST_MASTER_RESPONSE_CLEAR: "POST_MASTER_RESPONSE_CLEAR",
};
